// components/CloudImage.jsx
import { CloudinaryImage } from "@cloudinary/url-gen";
import { AdvancedImage, responsive, placeholder } from "@cloudinary/react";

export default function CloudImage({ publicId, alt }) {
  const img = new CloudinaryImage(publicId, { cloudName: "dqtcm6eo9" })
    .format("auto")
    .quality("auto");

  return (
    <AdvancedImage
      fetchpriority="high"
      cldImg={img}
      alt={alt}
      plugins={[responsive({ steps: 200 }), placeholder("blur")]}
    />
  );
}
